import useFetchSummary from "./useFetchSummary";
import useFetchSummaryStream from "./useFetchSummaryStream";

const useSummaryPage = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const streamId = queryParams.get("streamId") || "";
  useFetchSummary(streamId);
  useFetchSummaryStream(streamId);

};
export default useSummaryPage;
